// União das duas listas de métrica hoje divergentes (Dashboard/index.js e
// Dashboard/index_v2.js selecionavam por índice de array — causa do bug descrito
// em docs/PLANO_DASHBOARD_CONSOLIDADO.md). Aqui a seleção é sempre por `campo`
// (nome real do dado em metasMensais/getMetasCubo), nunca por posição.
const METRICAS = [
    { campo: "numTurmas", label: "N.° de Turmas" },
    { campo: "numAlunosTurmas", label: "N.º de Alunos Turmas" },
    { campo: "cargaHoraria", label: "Carga Horária" },
    { campo: "numMatriculasResiduais", label: "Mat. Residuais" },
    { campo: "numMatriculasNovas", label: "Mat. Novas" },
    { campo: "numTotalMatriculas", label: "Total Mat." },
    { campo: "horaAluno", label: "Hora/aluno" },
    { campo: "horaAlunoDistribuida", label: "Hora/aluno Distribuida" },
    { campo: "horaAlunoDistribuidaPercentualEvasao", label: "Hora/aluno Distribuida (% evasão)" },
    { campo: "cargaHorariaTurmaAno", label: "Carga H. Turma/Ano" },
    { campo: "necessidadeDocente8H", label: "Necessidade de docente (8h)" },
    { campo: "necessidadeDocente7H", label: "Necessidade de docente (7,2h)" },
];

function parseLabelCampo(campo) {
    let metrica = METRICAS.find((m) => m.campo === campo);
    return metrica && metrica.label;
}

module.exports = { METRICAS, parseLabelCampo };
